/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Create_HintInputs */

const cs_settings_venues_create_hint = /** @type {(inputs: Settings_Venues_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug nechte prázdný a vygeneruje se z názvu. Právnická osoba je volitelná — převezme se z kanceláře.`)
};

const en_settings_venues_create_hint = /** @type {(inputs: Settings_Venues_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave slug blank to generate it from the name. Legal entity is optional — inherit from the office.`)
};

/**
* | output |
* | --- |
* | "Leave slug blank to generate it from the name. Legal entity is optional — inherit from the office." |
*
* @param {Settings_Venues_Create_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_create_hint = /** @type {((inputs?: Settings_Venues_Create_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Create_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_create_hint(inputs)
	return cs_settings_venues_create_hint(inputs)
});